import React, { useContext, useState, useEffect } from 'react';
import {
    EmbeddedCheckoutProvider,
    EmbeddedCheckout
} from '@stripe/react-stripe-js';
import { fetchPaymentSession } from "../../http/userAPI";
import { Context } from "../../index";
import { loadStripe } from '@stripe/stripe-js';

const UserPaySubscriptionFull = ({ priceId }) => {
    const [clientSecret, setClientSecret] = useState(null);
    const [stripe, setStripe] = useState(null);
    const { user } = useContext(Context);

    // Функция получения сессии
    const fetchSession = async () => {
        try {
            console.log('Запрос сессии на сервер с ценой:', priceId);
            const data = await fetchPaymentSession(user.user.id, user.user.email, priceId, );

            if (data && data.client_secret) {
                setClientSecret(data.client_secret);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        fetchSession(); // Вызываем функцию при монтировании компонента
    }, [user.user.id, priceId]); // ✅ Следим за изменением `priceId`

    useEffect(() => {
        loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
            .then(setStripe)
            .catch(error => console.error("Error Stripe:", error));
    }, []);

    return (
        <>
            {clientSecret && stripe && (
                <EmbeddedCheckoutProvider
                    key={clientSecret}
                    stripe={stripe}
                    options={{ clientSecret }}
                >
                    <EmbeddedCheckout />
                </EmbeddedCheckoutProvider>
            )}
        </>
    );
};

export default UserPaySubscriptionFull;
